type Props = {
  children: JSX.Element
}

const Preloader = ({ children }: Props) => {
  return children
}

export { Preloader }
